// AUTO-GENERATED by scripts/generate-widget-registry.sh — DO NOT EDIT

import { definition as companyUearningsDef } from './items/data-provider/COMPANY_EARNINGS';
import { definition as companyUprofileDef } from './items/data-provider/COMPANY_PROFILE';
import { definition as consensusUtableDef } from './items/data-provider/CONSENSUS_TABLE';
import { definition as correlationDef } from './items/data-provider/CORRELATION';
import { definition as positionUriskDef } from './items/data-provider/POSITION_RISK';
import { definition as priceDef } from './items/data-provider/PRICE';
import { definition as convictionDef } from './items/input/conviction';
import { definition as qaDef } from './items/input/qa';
import { definition as scorecardDef } from './items/input/scorecard';
import { definition as onedriveDef } from './items/microsoft/onedrive';
import { definition as outlookDef } from './items/microsoft/outlook';
import { definition as dashboardUreferenceDef } from './items/reference/dashboard_reference';
import { definition as imageUrepositoryDef } from './items/repository/image_repository';
import { definition as notesUrepositoryDef } from './items/repository/notes_repository';
import { definition as pdfUrepositoryDef } from './items/repository/pdf_repository';

// All widget definitions (sorted by file path)
export const definitions = [
  companyUearningsDef,
  companyUprofileDef,
  consensusUtableDef,
  correlationDef,
  positionUriskDef,
  priceDef,
  convictionDef,
  qaDef,
  scorecardDef,
  onedriveDef,
  outlookDef,
  dashboardUreferenceDef,
  imageUrepositoryDef,
  notesUrepositoryDef,
  pdfUrepositoryDef,
];
